// @flow
import {
  actions as PurchasedProductsActions,
  initialState as ReceptionInitialState,
} from './recepetion/duck';
import ReceptionReducer from './recepetion/duck';

import type { ReceptionState } from "./recepetion/duck";

type CourierAction = {
  +type: string;
};

export type CourierState = {
  +inCourierFlowOrdersState: ReceptionState;
};

// Actions
const COURIER_RESET_STATE = 'COURIER_RESET_STATE';

// Action Creators
export function resetState(): CourierAction {
  return {
    type: COURIER_RESET_STATE,
  };
}

export const actions = {
  COURIER_RESET_STATE,
  resetState,
};

export const initialState: CourierState = {
  inCourierFlowOrdersState: ReceptionInitialState,
};

// Reducer
export default function reducer(state: CourierState = initialState,
                                action: CourierAction): CourierState {
  switch (action.type) {
    case PurchasedProductsActions.RECEPTION_FETCH_RECEPTION_ORDERS_REQUEST:
    case PurchasedProductsActions.RECEPTION_FETCH_RECEPTION_ORDERS_SUCCESS:
    case PurchasedProductsActions.RECEPTION_FETCH_RECEPTION_ORDERS_ERROR:
    case PurchasedProductsActions.RECEPTION_RECEIVE_ORDER_ITEM_REQUEST:
    case PurchasedProductsActions.RECEPTION_RECEIVE_ORDER_ITEM_SUCCESS:
    case PurchasedProductsActions.RECEPTION_RECEIVE_ORDER_ITEM_ERROR:
    case PurchasedProductsActions.RECEPTION_RESET_STATE:
      return {
        ...state,
        inCourierFlowOrdersState: ReceptionReducer(state.inCourierFlowOrdersState, (action: any)),
      };
    case COURIER_RESET_STATE:
      return initialState;
    default:
      return state;
  }
}

// Epics



// WEBPACK FOOTER //
// ./src/modules/courier/duck.js